import identity from "lodash/fp/identity";

class RatingsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default RatingsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.transforms.js